export default __webpack_public_path__ + "static/media/Mark-4-HUD-05.f34014cb.jpg";